import dayjs from 'dayjs';

export const dateValidator = (startDate, endDate, interval, setSnackbar, options = {}) => {
  const currentDay = dayjs();
  if (!startDate) {
    setSnackbar("No se ha seleccionado fecha de inicio.", 'warning');
    return true;
  }
  if (!endDate) {
    setSnackbar("No se ha seleccionado fecha final.", 'warning');
    return true;
  }
  if (!dayjs(startDate).isSameOrBefore(dayjs(endDate), "day")) {
    setSnackbar("La fecha final no puede ser menor a la inicial.", 'warning');
    return true;
  }
  if (interval && dayjs(endDate).diff(dayjs(startDate), "day") > interval - 1) {
    setSnackbar(`La fecha inicial no puede ser menor a ${interval} dias a la fecha final`, 'warning');
    return true;
  }
  if (!options.allowFutureDates && endDate > currentDay) {
    setSnackbar("La fecha final no puede ser mayor al día actual", 'warning');
    return true;
  }
  if (options.range) {
    const { min, max } = options.range;
    if (min && dayjs(startDate).isBefore(dayjs(min), 'day')) {
      setSnackbar(`La fecha inicial no puede ser menor a ${min}`, 'warning');
      return true;
    }
    if (max && dayjs(endDate).isAfter(dayjs(max), 'day')) {
      setSnackbar(`La fecha final no puede ser mayor a ${max}`, 'warning');
      return true;
    }
  }

  return false;
}
